import { Component, Inject, OnInit } from '@angular/core';
import { DialogService } from '../../services/dialog.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';




@Component({
  selector: 'sd-lyrics-dialog',
  templateUrl: './lyrics-dialog.component.html',
  styleUrls: ['./lyrics-dialog.component.scss']
})
export class LyricsDialogComponent implements OnInit {
  

  constructor(
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
   
    private lyricsDialogRef: MatDialogRef<LyricsDialogComponent>,
    public dialog: DialogService,) { }

  ngOnInit(): void {
  }
  closeDialog() {
    this.lyricsDialogRef.close('');
}
}
